module.exports = __webpack_public_path__ + "static/media/meh.13985738.svg";